export default __webpack_public_path__ + "media/images/chateau_de_chillon-61949aa77670938eb1159169bdbfd381.jpg";